export const assertTokenExpiration = <T>(
    token: T & {
        exp?: number;
    }
): token is T & { exp: number } => {
    const now = Math.round(Date.now() / 1000);

    return typeof token.exp === 'number' && token.exp - now > 0;
};
